import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  applications,
  statusHistory,
  clearStatusHistory,
} from "~/redux/actions/talent";

import { Card, Menu, Badge, Empty } from "antd";
import ApplicationItem from "../components/users/ApplicationItem";

import SiteLayout from "~/components/layout/SiteLayout";
import StatusCard from "../components/sider/StatusCard";
import Loading from "~/components/app/Loading";
import _ from "lodash";

const Page = (props) => {
  const [currentCandidateId, setCurrentCandidateId] = useState();
  const [data, setData] = useState();
  const [category, setCategory] = useState("processing_candidates");

  const pageSider = <StatusCard candidateId={currentCandidateId} />;

  useEffect(() => {
    if (props.applicationData) {
      const candidates = _.filter(props.applicationData.candidates, (o) => {
        return [
          "new",
          "contacting",
          "interviewing",
          "accepted",
          "offering",
          "offered",
        ].includes(o.status);
      });
      setData(candidates);
      if (candidates.length > 0) {
        setCurrentCandidateId(candidates[0].id);
      } else {
        props.clearStatusHistory();
      }
    }
  }, [props.applicationData]);

  useEffect(() => {
    currentCandidateId &&
      props.statusHistory({
        token: props.token,
        candidate_id: currentCandidateId,
      });
  }, [currentCandidateId]);

  const handleCategoryChange = (obj) => {
    let status_arr = [];
    switch (obj.key) {
      case "processing_candidates":
        status_arr = [
          "new",
          "contacting",
          "interviewing",
          "accepted",
          "offering",
          "offered",
        ];
        break;
      case "rejected_candidates":
        status_arr = ["rejected", "admin_rejected"];
        break;
      case "cancelled_candidates":
        status_arr = ["cancelled", "candidate_rejected"];
        break;

      case "hired_candidates":
        status_arr = ["hired"];
        break;
    }
    props.clearStatusHistory();
    setCategory(obj.key);
    const candidates = _.filter(props.applicationData.candidates, (o) => {
      if (obj.key === "rejected_candidates") {
        return (
          status_arr.includes(o.candidate_status.to) &&
          o.candidate_status.from !== "hired"
        );
      } else if (obj.key === "hired_candidates") {
        return (
          status_arr.includes(o.candidate_status.to) ||
          o.candidate_status.from === "hired"
        );
      } else {
        return status_arr.includes(o.candidate_status.to);
      }
    });
    setData(candidates);
    setCurrentCandidateId("");
    candidates[0] && setCurrentCandidateId(candidates[0].id);
  };

  const handleInit = () => {
    if (props.token) {
      props.applications({ token: props.token });
    }
  };

  useEffect(() => handleInit(), []);

  return (
    <SiteLayout pageTitle="职位状态" pageSider={pageSider}>
      <Card style={{ minHeight: "600px" }}>
        <Menu
          mode="horizontal"
          selectedKeys={category}
          onSelect={handleCategoryChange}
        >
          <Menu.Item key="processing_candidates">
            <Badge>进行中</Badge>
          </Menu.Item>
          <Menu.Item key="rejected_candidates">
            <Badge>被拒绝</Badge>
          </Menu.Item>
          <Menu.Item key="cancelled_candidates">
            <Badge>主动取消</Badge>
          </Menu.Item>
          <Menu.Item key="hired_candidates">
            <Badge>已入职</Badge>
          </Menu.Item>
        </Menu>

        <div>
          {data ? (
            data.length > 0 ? (
              data.map((a) => (
                <div
                  onClick={() => {
                    setCurrentCandidateId(a.id);
                  }}
                >
                  <ApplicationItem
                    className={a.id === currentCandidateId && "selected"}
                    key={a.id}
                    application={a}
                  />
                </div>
              ))
            ) : (
              <Empty className="mt-20"></Empty>
            )
          ) : (
            <Loading />
          )}
        </div>
      </Card>
    </SiteLayout>
  );
};

Page.requireUser = () => true;
const mapStateToProps = (state) => ({
  token: state.user.token,
  applicationData: state.talent.applicationData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { applications, statusHistory, clearStatusHistory },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Page);
